/* ============================================================
   NDI Request-a-Quote modal
   ============================================================
   Markup: snippets/ndi-quote-modal.liquid
   Styles: assets/ndi-component-quote-modal.css

   Opens from any `.open-quote` element. Product search + bulk SKU
   paste + qty table; the quote persists across pages via localStorage.
   Prices are converted from the visitor's
   Shopify Markets presentment currency back to the shop's base
   currency for the admin email. Submits via the native `contact`
   form and pushes a GTM `quote_submit` event.
   ============================================================ */
(function () {
  const modal = document.getElementById('ndi-quote-modal');
  const closeBtn = document.getElementById('ndi-quote-close');
  const messageModal = document.getElementById('ndi-quote-message-modal');
  const closeMessageBtn = document.getElementById('ndi-quote-message-close');
  if (!modal || !closeBtn || !messageModal || !closeMessageBtn) return;

  // ----- Currency bootstrap -----
  // Shop base currency comes from a data attribute (no Liquid in JS assets).
  const SHOP_CURRENCY = modal.dataset.shopCurrency || 'USD';

  // Escape user-derived strings (product title/SKU from the Search JSON / triggers)
  // before they touch innerHTML — a title with < or " would otherwise break markup
  // or inject. Used everywhere we build row HTML from product data.
  function esc(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  const CURRENCY_SYMBOLS = {
    USD: '$', CAD: 'CA$', AUD: 'AU$', NZD: 'NZ$', HKD: 'HK$', SGD: 'S$',
    MXN: 'MX$', BRL: 'R$', ARS: 'AR$', CLP: 'CL$', COP: 'CO$',
    EUR: '€', GBP: '£', JPY: '¥', CNY: '¥', KRW: '₩',
    INR: '₹', RUB: '₽', TRY: '₺', ILS: '₪', ZAR: 'R',
    CHF: 'CHF', SEK: 'kr', NOK: 'kr', DKK: 'kr', PLN: 'zł', CZK: 'Kč',
    HUF: 'Ft', THB: '฿', PHP: '₱', AED: 'AED', SAR: 'SAR'
  };
  const ZERO_DECIMAL = new Set(['JPY', 'KRW', 'CLP', 'HUF', 'VND', 'IDR']);

  function getPresentmentCurrency() {
    try {
      if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
        return window.Shopify.currency.active;
      }
    } catch (e) { /* no-op */ }
    return SHOP_CURRENCY;
  }

  function getPresentmentRate() {
    try {
      const r = parseFloat(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate);
      if (Number.isFinite(r) && r > 0) return r;
    } catch (e) { /* no-op */ }
    return 1;
  }

  function symbolFor(code) {
    return CURRENCY_SYMBOLS[code] || '';
  }

  function formatAmount(amount, currency) {
    const sym = symbolFor(currency);
    const decimals = ZERO_DECIMAL.has(currency) ? 0 : 2;
    const n = (parseFloat(amount) || 0).toFixed(decimals);
    const parts = n.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (sym ? sym : '') + parts.join('.') + ' ' + currency;
  }

  // Convert a presentment amount back to the shop's base currency.
  function toShopBase(presentmentAmount) {
    const rate = getPresentmentRate();
    if (!rate || rate === 1) return presentmentAmount;
    return presentmentAmount / rate;
  }

  // Quote persists across pages (localStorage — survives tab close; B2B users
  // build big quotes over multiple visits). One key, JSON array of line items.
  const STORAGE_KEY = 'ndiQuoteProducts';
  function loadPersisted() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) { return []; }
  }
  function persist() {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(selectedProductsList)); } catch (e) { /* quota/private mode */ }
  }
  function clearPersisted() {
    try { localStorage.removeItem(STORAGE_KEY); } catch (e) { /* no-op */ }
  }

  let selectedProductsList = loadPersisted();

  // Snapshot the current product's hidden context fields ONCE at load. The submit
  // handler removes these inputs from the DOM (they're email-context only), so
  // reading them live in populateCurrentProduct() would return nothing on any
  // re-open after the first submit — the current product would silently stop
  // auto-adding. Capturing here keeps re-opens working for the whole session.
  const currentProductSnapshot = (function () {
    const titleInput = document.querySelector('input[name="contact[product_title]"]');
    if (!titleInput || !titleInput.value) return null;
    const idInput = document.querySelector('input[name="contact[variant_id]"]');
    const skuInput = document.querySelector('input[name="contact[variant_sku]"]');
    const urlInput = document.querySelector('input[name="contact[product_url]"]');
    const priceInput = document.querySelector('input[name="contact[variant_price]"]');
    return {
      title: titleInput.value,
      id: (idInput && idInput.value) || '',
      sku: (skuInput && skuInput.value) || '',
      url: (urlInput && urlInput.value) || '',
      price: (priceInput && priceInput.value) || '',
    };
  })();

  // ----- Open / close -----
  // Both roots are <dialog>. showModal() supplies the focus trap, aria-modal,
  // Esc-to-close and focus restoration natively — the only thing it does NOT do
  // is lock page scroll, so that stays manual. Esc bypasses close() entirely,
  // which is why the scroll unlock hangs off the native `close` event.
  function open() {
    if (modal.open) return;
    modal.showModal();
    document.documentElement.style.overflow = 'hidden';
    populateCurrentProduct();
  }
  function close() {
    modal.close();
  }

  modal.addEventListener('close', () => {
    document.documentElement.style.overflow = '';
  });
  messageModal.addEventListener('close', () => {
    document.documentElement.style.overflow = '';
  });

  function showMessage(type, title, text) {
    const icon = document.getElementById('ndi-quote-message-icon');
    const titleEl = document.getElementById('ndi-quote-message-title');
    const textEl = document.getElementById('ndi-quote-message-text');

    icon.className = 'ndi-quote-msg__icon';
    titleEl.className = 'ndi-quote-msg__title';
    closeMessageBtn.className = 'ndi-quote-msg__close';

    icon.classList.add('is-' + type);
    titleEl.classList.add('is-' + type);
    closeMessageBtn.classList.add('is-' + type);

    titleEl.textContent = title;
    textEl.textContent = text;

    if (!messageModal.open) messageModal.showModal();
    document.documentElement.style.overflow = 'hidden';
  }

  function closeMessage() {
    messageModal.close();
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.open-quote');
    if (btn) {
      e.preventDefault();
      if (btn.dataset.quoteId) addFromTrigger(btn);
      open();
    }
  });

  // Seed a product from a trigger's data-quote-* attributes (e.g. product-card
  // Quote button). Price arrives in cents (shop base? no — presentment, same as
  // the storefront shows), so mirror selectProduct's cents→display conversion.
  function addFromTrigger(btn) {
    const id = btn.dataset.quoteId;
    if (selectedProductsList.find((p) => p.id == id)) return; // already in the quote
    const displayPrice = (parseInt(btn.dataset.quotePrice, 10) || 0) / 100;
    selectedProductsList.push({
      id: id,
      title: btn.dataset.quoteTitle || '',
      sku: btn.dataset.quoteSku || 'N/A',
      basePrice: toShopBase(displayPrice),
      displayPrice: displayPrice,
      displayCurrency: getPresentmentCurrency(),
      price: displayPrice,
      url: btn.dataset.quoteUrl || window.location.pathname,
      quantity: 1,
    });
    updateSelectedProducts();
  }

  closeBtn.addEventListener('click', close);
  closeMessageBtn.addEventListener('click', closeMessage);

  modal.addEventListener('click', (e) => {
    if (e.target === modal) close();
  });
  messageModal.addEventListener('click', (e) => {
    if (e.target === messageModal) closeMessage();
  });

  const form = document.getElementById('ndi-quote-form');

  // Show the confirmation dialog after a contact-form round trip.
  if (form) {
    const successMessage = form.querySelector('.ndi-quote__success');
    const errorMessage = form.querySelector('.ndi-quote__error');

    // ⚠️ Shopify marks EVERY {% form 'contact' %} on the page as posted, and this modal
    // renders site-wide — so `.ndi-quote__success` existing means only that SOME contact
    // form posted, not that it was this one. Gating on "the modal was opened once this
    // session" was not enough: submitting the form on /pages/contact-us-inquiry popped
    // "Quote Sent!" alongside the real confirmation. The flag below is set in this form's
    // own submit handler, so only a real quote submit can show it. Consumed on read, which
    // is also what stops a refresh from re-showing it.
    const submitted = sessionStorage.getItem('ndiQuoteSubmitted');
    if (submitted) sessionStorage.removeItem('ndiQuoteSubmitted');

    if (submitted && successMessage) {
      close();
      setTimeout(() => {
        showMessage('success', 'Quote Sent!', 'Thanks! We\'ve received your quote request and will get back to you soon.');
        form.reset();
        selectedProductsList = [];
        clearPersisted();
        updateSelectedProducts();
      }, 300);
    } else if (submitted && errorMessage) {
      close();
      setTimeout(() => {
        showMessage('error', 'Submission Error', 'Please check the highlighted fields and try again.');
      }, 300);
    }
  }

  // Build the product list text + GTM event on submit.
  if (form) {
    form.addEventListener('submit', function () {
      // Marks the round-trip as OURS, so the post-navigation success/error block above
      // knows this form was the one submitted (see the note there).
      sessionStorage.setItem('ndiQuoteSubmitted', '1');

      // NDI: fire a bare conversion event only — NO PII. Sending the raw email to
      // GTM/dataLayer is a privacy issue (and would need consent gating). If a
      // hashed identifier is ever needed, hash before pushing. [[cookie-consent]]
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'quote_submit' });

      // Strip context-only hidden fields from the email.
      ['contact[page]', 'contact[product_title]', 'contact[product_handle]',
        'contact[product_url]', 'contact[variant_sku]', 'contact[variant_id]',
        'contact[variant_price]'].forEach((name) => {
        const field = form.querySelector(`input[name="${name}"]`);
        if (field) field.remove();
      });

      const commentTextarea = form.querySelector('textarea[name="contact[body]"]');
      if (commentTextarea && selectedProductsList.length > 0) {
        const presentmentCurrency =
          (selectedProductsList[0] && selectedProductsList[0].displayCurrency) ||
          getPresentmentCurrency();
        const presentmentRate = getPresentmentRate();
        const showPresentment =
          presentmentCurrency && presentmentCurrency !== SHOP_CURRENCY;

        let grandTotalDisplay = 0;
        selectedProductsList.forEach((p) => {
          const qty = parseInt(p.quantity) || 1;
          const display = parseFloat(p.displayPrice != null ? p.displayPrice : p.price) || 0;
          grandTotalDisplay += display * qty;
        });

        // Markets rounds presentment prices, so back-converted USD drifts a
        // few cents. Snap to whole dollars to match the admin price.
        function roundUsdForEmail(amount) {
          return showPresentment ? Math.round(amount) : amount;
        }

        function formatLine(baseAmount, displayAmount, displayCurrency) {
          const base = formatAmount(roundUsdForEmail(baseAmount), SHOP_CURRENCY);
          if (showPresentment) {
            return base + '  (customer saw ' + formatAmount(displayAmount, displayCurrency) + ')';
          }
          return base;
        }

        let productsTable = 'QUOTE REQUEST - PRODUCT LIST\n\n';
        selectedProductsList.forEach((p, index) => {
          const quantity = parseInt(p.quantity) || 1;
          if (p.notFound) {
            productsTable += `SKU: ${p.sku || 'N/A'}\n`;
            productsTable += 'Unit Price: NOT FOUND IN STORE\n';
            productsTable += `QTY: ${quantity}\n`;
            productsTable += 'Total Price: NOT FOUND IN STORE\n';
            if (index < selectedProductsList.length - 1) productsTable += '--------------------\n';
            return;
          }
          const basePrice = parseFloat(p.basePrice) || 0;
          const displayPrice = parseFloat(p.displayPrice != null ? p.displayPrice : p.price) || 0;
          const lineCurrency = p.displayCurrency || SHOP_CURRENCY;
          const roundedUnitBase = roundUsdForEmail(basePrice);
          const baseTotal = roundedUnitBase * quantity;
          const displayTotal = displayPrice * quantity;

          productsTable += `SKU: ${p.sku || 'N/A'}\n`;
          productsTable += `Unit Price: ${formatLine(basePrice, displayPrice, lineCurrency)}\n`;
          productsTable += `QTY: ${quantity}\n`;
          productsTable += `Total Price: ${formatLine(baseTotal, displayTotal, lineCurrency)}\n`;
          if (index < selectedProductsList.length - 1) productsTable += '--------------------\n';
        });

        let grandTotalBaseRounded = 0;
        selectedProductsList.forEach((p) => {
          const qty = parseInt(p.quantity) || 1;
          const base = parseFloat(p.basePrice) || 0;
          grandTotalBaseRounded += roundUsdForEmail(base) * qty;
        });

        productsTable += '\n----------------------\n';
        productsTable += `Grand Total: ${formatLine(grandTotalBaseRounded, grandTotalDisplay, presentmentCurrency)}`;
        if (showPresentment) {
          productsTable += `\nCustomer was browsing in ${presentmentCurrency} (rate used: ${presentmentRate})`;
        }

        commentTextarea.value = commentTextarea.value.trim() +
          '\n\n=== REQUESTED PRODUCTS ===\n\n' + productsTable;
      }
    });
  }

  // Auto-add the current product (product template only). Uses the load-time
  // snapshot, not live DOM, so it keeps working after the submit handler strips
  // the hidden context fields.
  function populateCurrentProduct() {
    if (!currentProductSnapshot) return;

    const priceCents = parseInt(currentProductSnapshot.price, 10);
    const displayPrice = Number.isFinite(priceCents) ? priceCents / 100 : 0;
    const currentProduct = {
      id: currentProductSnapshot.id || String(Date.now()),
      title: currentProductSnapshot.title,
      sku: currentProductSnapshot.sku || 'N/A',
      basePrice: toShopBase(displayPrice),
      displayPrice: displayPrice,
      displayCurrency: getPresentmentCurrency(),
      price: displayPrice,
      url: currentProductSnapshot.url || window.location.pathname,
      quantity: 1,
    };
    if (!selectedProductsList.find((p) => p.id == currentProduct.id)) {
      selectedProductsList.push(currentProduct);
      updateSelectedProducts();
    }
  }

  // ----- Product search -----
  const searchInput = document.getElementById('ndi-quote-search');
  const searchResults = document.getElementById('ndi-quote-results');
  let searchTimeout;

  // Cache responses by query. The search endpoint costs 200-600ms, so without
  // this every backspace pays full network latency again for a result set we
  // already had. Keyed by the exact trimmed query, capped so a long typing
  // session can't grow it without bound.
  const searchCache = new Map();
  const SEARCH_CACHE_MAX = 50;
  // Rising counter so a slow early response can't overwrite a newer one.
  let searchSeq = 0;

  function cacheGet(query) {
    return searchCache.get(query.toLowerCase());
  }
  function cacheSet(query, results) {
    if (searchCache.size >= SEARCH_CACHE_MAX) {
      searchCache.delete(searchCache.keys().next().value); // drop oldest
    }
    searchCache.set(query.toLowerCase(), results);
  }
  // Results for the longest cached query that `query` starts with — the best
  // local guess to show while the real request is in flight.
  function longestCachedPrefix(query) {
    const q = query.toLowerCase();
    let best = null;
    let bestLen = 0;
    searchCache.forEach((results, key) => {
      if (key.length > bestLen && key.length < q.length && q.startsWith(key)) {
        best = results;
        bestLen = key.length;
      }
    });
    return best;
  }

  if (searchInput && searchResults) {
    searchInput.addEventListener('input', function () {
      clearTimeout(searchTimeout);
      const query = this.value.trim();
      if (query.length < 2) {
        searchResults.classList.add('is-hidden');
        return;
      }
      // Already fetched this exact query (retyping, backspacing, pasting)? Render
      // it synchronously — no debounce, no network, no perceptible delay.
      const cached = cacheGet(query);
      if (cached) {
        displaySearchResults(cached);
        return;
      }
      // No exact hit, but a shorter prefix is cached: narrow those results locally
      // and show them NOW, so typing never blanks the list. The real request still
      // goes out below and replaces this once it lands (the server may know about
      // matches that weren't in the prefix's top 10).
      const prefixHit = longestCachedPrefix(query);
      if (prefixHit) {
        const needle = query.toLowerCase();
        displaySearchResults(
          prefixHit.filter((p) =>
            (p.title || '').toLowerCase().includes(needle) ||
            (p.sku || '').toLowerCase().includes(needle)
          )
        );
      }
      // 120ms instead of 300ms: still coalesces a fast typist's keystrokes into
      // one request, but is below the ~150ms threshold where a UI stops feeling
      // immediate. Combined with the cache this is the only wait a user sees.
      searchTimeout = setTimeout(() => performSearch(query), 120);
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.ndi-quote__search-wrap')) {
        searchResults.classList.add('is-hidden');
      }
    });
  }

  function performSearch(query) {
    const seq = ++searchSeq;
    fetch(`/search?type=product&q=${encodeURIComponent(query)}&view=json`)
      .then((r) => {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then((data) => {
        const results = data.results || [];
        cacheSet(query, results);
        // Render only if this is still the newest request AND the box still holds
        // the query it was fired for — otherwise a slow response would clobber
        // fresher results.
        if (seq === searchSeq && searchInput.value.trim() === query) {
          displaySearchResults(results);
        }
      })
      .catch((err) => {
        console.error('Quote search error:', err);
        if (seq === searchSeq) searchResults.classList.add('is-hidden');
      });
  }

  function displaySearchResults(results) {
    searchResults.innerHTML = '';
    if (results.length === 0) {
      searchResults.classList.add('is-hidden');
      return;
    }
    results.slice(0, 8).forEach((product) => {
      const item = document.createElement('div');
      item.className = 'ndi-quote__result';
      item.innerHTML =
        `<div class="ndi-quote__result-info">
          <div class="ndi-quote__result-title">${esc(product.title)}</div>
          <div class="ndi-quote__result-sku">SKU: ${esc(product.sku || 'N/A')}</div>
        </div>`;
      item.addEventListener('click', () => {
        selectProduct(product);
        searchInput.value = '';
        searchResults.classList.add('is-hidden');
      });
      searchResults.appendChild(item);
    });
    searchResults.classList.remove('is-hidden');
  }

  function selectProduct(product) {
    if (selectedProductsList.find((p) => p.id === product.id)) return;
    product.quantity = 1;
    const displayPrice = (parseFloat(product.price) || 0) / 100;
    product.displayCurrency = getPresentmentCurrency();
    product.displayPrice = displayPrice;
    product.basePrice = toShopBase(displayPrice);
    product.price = displayPrice;
    selectedProductsList.push(product);
    updateSelectedProducts();
  }

  // ----- Bulk paste -----
  const bulkToggle = document.getElementById('ndi-quote-bulk-toggle');
  const bulkPanel = document.getElementById('ndi-quote-bulk-panel');
  const bulkInput = document.getElementById('ndi-quote-bulk-input');
  const bulkAddBtn = document.getElementById('ndi-quote-bulk-add');
  const bulkStatus = document.getElementById('ndi-quote-bulk-status');

  if (bulkToggle && bulkPanel) {
    bulkToggle.addEventListener('click', () => {
      bulkPanel.classList.toggle('is-hidden');
      if (!bulkPanel.classList.contains('is-hidden')) bulkInput.focus();
    });
  }

  function parseBulkLines(text) {
    const seen = new Set();
    const entries = [];
    text.split(/[\n,]+/).forEach((part) => {
      const sku = part.trim();
      if (!sku) return;
      const key = sku.toLowerCase();
      if (seen.has(key)) return;
      seen.add(key);
      entries.push({ sku: sku, quantity: 1 });
    });
    return entries;
  }

  function lookupSku(sku) {
    return fetch(`/search?type=product&q=${encodeURIComponent(sku)}&view=json`)
      .then((r) => (r.ok ? r.json() : { results: [] }))
      .then((data) => {
        const results = (data && data.results) || [];
        const wanted = sku.toLowerCase();
        let hit = results.find((p) => (p.sku || '').toLowerCase() === wanted);
        if (!hit) hit = results.find((p) => (p.sku || '').toLowerCase().includes(wanted));
        return hit || null;
      })
      .catch(() => null);
  }

  function addFoundProduct(product, sku, quantity) {
    const displayPrice = (parseFloat(product.price) || 0) / 100;
    const entry = Object.assign({}, product);
    entry.quantity = quantity;
    entry.displayCurrency = getPresentmentCurrency();
    entry.displayPrice = displayPrice;
    entry.basePrice = toShopBase(displayPrice);
    entry.price = displayPrice;
    if (!entry.sku) entry.sku = sku;
    selectedProductsList.push(entry);
  }

  function addNotFoundProduct(sku, quantity) {
    selectedProductsList.push({
      id: 'notfound-' + sku + '-' + Date.now() + '-' + Math.random().toString(36).slice(2, 7),
      title: 'Not found in store',
      sku: sku,
      quantity: quantity,
      notFound: true,
      basePrice: 0,
      displayPrice: 0,
      price: 0,
      displayCurrency: getPresentmentCurrency(),
    });
  }

  // Shared lookup pipeline for both paste and file upload. Returns a promise.
  function processEntries(entries, statusEl) {
    if (!entries || entries.length === 0) {
      statusEl.textContent = 'Nothing to add.';
      return Promise.resolve();
    }
    statusEl.textContent = 'Looking up ' + entries.length + ' SKU(s)...';
    if (bulkAddBtn) bulkAddBtn.disabled = true;

    let added = 0, notFound = 0, skipped = 0;
    const tasks = entries.map((entry) =>
      lookupSku(entry.sku).then((product) => {
        if (product) {
          if (selectedProductsList.find((p) => p.id === product.id && !p.notFound)) {
            skipped++;
            return;
          }
          addFoundProduct(product, entry.sku, entry.quantity);
          added++;
        } else {
          addNotFoundProduct(entry.sku, entry.quantity);
          notFound++;
        }
      })
    );

    return Promise.all(tasks).then(() => {
      updateSelectedProducts();
      if (bulkAddBtn) bulkAddBtn.disabled = false;
      let msg = added + ' added';
      if (notFound > 0) msg += ', ' + notFound + ' not found';
      if (skipped > 0) msg += ', ' + skipped + ' already in list';
      statusEl.textContent = msg + '.';
    });
  }

  function handleBulkAdd() {
    if (!bulkInput) return;
    processEntries(parseBulkLines(bulkInput.value), bulkStatus).then(() => {
      bulkInput.value = '';
    });
  }

  if (bulkAddBtn) bulkAddBtn.addEventListener('click', handleBulkAdd);

  // ----- Table render -----
  function removeProduct(productId) {
    selectedProductsList = selectedProductsList.filter((p) => p.id != productId);
    updateSelectedProducts();
  }

  function updateProductQuantity(productId, quantity) {
    const product = selectedProductsList.find((p) => p.id == productId);
    if (!product) return;
    product.quantity = quantity;
    persist(); // qty edits update one cell (to keep focus) → persist here, not via updateSelectedProducts
    if (product.notFound) return;
    // Update only this row's total so the live <input> keeps focus.
    const input = document.querySelector('.ndi-quote__qty[data-product-id="' + CSS.escape(String(productId)) + '"]');
    if (!input) return;
    const row = input.closest('tr');
    const totalCell = row && row.querySelector('.ndi-quote__total');
    if (!totalCell) return;
    const unitPrice = parseFloat(product.displayPrice != null ? product.displayPrice : product.price) || 0;
    totalCell.textContent = formatAmount(unitPrice * quantity, product.displayCurrency || SHOP_CURRENCY);
  }

  const clearBtn = document.getElementById('ndi-quote-clear');
  if (clearBtn) {
    clearBtn.addEventListener('click', () => {
      selectedProductsList = [];
      clearPersisted();
      updateSelectedProducts();
    });
  }

  function updateSelectedProducts() {
    persist(); // single choke point for every add/remove/qty change
    const tbody = document.getElementById('ndi-quote-tbody');
    if (!tbody) return;

    // Show "Clear all" only when the table has rows.
    if (clearBtn) clearBtn.classList.toggle('is-hidden', selectedProductsList.length === 0);

    if (selectedProductsList.length === 0) {
      tbody.innerHTML =
        `<tr class="ndi-quote__empty"><td colspan="6">No products selected. Search and select products above to add them here.</td></tr>`;
      return;
    }

    tbody.innerHTML = selectedProductsList.map((product) => {
      const quantity = parseInt(product.quantity) || 1;
      if (product.notFound) {
        return `<tr class="is-not-found">
          <td><div class="ndi-quote__selected-name ndi-quote__not-found">Not found in store</div></td>
          <td><div class="ndi-quote__selected-sku">${esc(product.sku || 'N/A')}</div></td>
          <td><div class="ndi-quote__price ndi-quote__na">N/A</div></td>
          <td><input type="text" value="${quantity}" class="ndi-quote__qty" data-product-id="${esc(product.id)}"></td>
          <td><div class="ndi-quote__total ndi-quote__na">N/A</div></td>
          <td><button type="button" class="ndi-quote__remove" data-product-id="${esc(product.id)}">Remove</button></td>
        </tr>`;
      }
      const unitPrice = parseFloat(product.displayPrice != null ? product.displayPrice : product.price) || 0;
      const currency = product.displayCurrency || SHOP_CURRENCY;
      return `<tr>
        <td><div class="ndi-quote__selected-name">${esc(product.title)}</div></td>
        <td><div class="ndi-quote__selected-sku">${esc(product.sku || 'N/A')}</div></td>
        <td><div class="ndi-quote__price">${formatAmount(unitPrice, currency)}</div></td>
        <td><input type="text" value="${quantity}" class="ndi-quote__qty" data-product-id="${esc(product.id)}"></td>
        <td><div class="ndi-quote__total">${formatAmount(unitPrice * quantity, currency)}</div></td>
        <td><button type="button" class="ndi-quote__remove" data-product-id="${esc(product.id)}">Remove</button></td>
      </tr>`;
    }).join('');

    tbody.querySelectorAll('.ndi-quote__remove').forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        removeProduct(e.target.getAttribute('data-product-id'));
      });
    });

    tbody.querySelectorAll('.ndi-quote__qty').forEach((input) => {
      input.addEventListener('input', (e) => {
        updateProductQuantity(e.target.getAttribute('data-product-id'), parseInt(e.target.value) || 1);
      });
    });
  }

  // Render any persisted quote so it's visible the moment the modal opens.
  if (selectedProductsList.length) updateSelectedProducts();
})();
